import { ReactNode, Children, cloneElement, ReactElement, isValidElement } from 'react'
import cn from 'classnames'
import { path } from 'ramda'

import { AvailableDisplayName, isAvailableDisplayName } from './available-display-name'
import type { HandleModalDisplayed } from './use-modal-displayed'
import styles from './plain-modal-container.module.scss'

type Props = {
  children: ReactNode
  className?: string
  handleModalDisplayed?: HandleModalDisplayed
}

const PlainModalContainer = ({ children, className, handleModalDisplayed }: Props): ReactNode => {
  const elements = Children.toArray(children).filter((child): child is ReactElement =>
    isValidElement(child),
  ) as Array<ReactElement<Record<string, unknown> | undefined>>
  return (
    <div className={cn(styles.root, className)}>
      {Children.map(elements, (component) => {
        const displayName = path(['type', 'displayName'], component)
        if (
          isAvailableDisplayName(displayName) &&
          typeof component === 'object' &&
          'props' in component
        ) {
          const { props } = component
          if (path(['unscrollable'], props)) {
            return cloneElement(component, { ...props, handleModalDisplayed })
          }
          return (
            <div>
              {/* ^^^ div - because Scrollbars */}
              {cloneElement(component, { ...props, handleModalDisplayed })}
            </div>
          )
        }
        console.log('%c👻 Неверный child для PlainModalContainer', 'color: LawnGreen')
        return null
      })}
    </div>
  )
}

PlainModalContainer.displayName = AvailableDisplayName.PlainModalContainer

export default PlainModalContainer
